// Partir un nombre completo en nombres y apellidos.
//
// En Mexico el apellido PATERNO va primero, asi que tomar la ultima palabra da el
// materno: "Monica Ruiz Gandara" -> "Gandara". Ese error es el que produjo familias
// duplicadas, porque el mismo responsable capturado con uno o dos apellidos generaba
// dos nombres de familia distintos.
//
// Se arma de DERECHA A IZQUIERDA porque las particulas ("de la", "del") pertenecen al
// apellido que va a su derecha, no al de su izquierda.
//
// Medido contra produccion: 232 de 232 jugadores y 109 de 139 responsables. Los
// jugadores salen perfectos porque se capturan con CURP contra un acta; los
// responsables se capturan al vuelo y ahi aparecen "Cecy", "Grisel" y un "XXXX".

const PARTICULAS = new Set([
  'de', 'del', 'la', 'las', 'los', 'y', 'e',
  'van', 'von', 'di', 'da', 'dos', 'mac', 'mc', 'san', 'santa',
])

// Lo que la gente escribio como aclaracion y no es apellido.
const ACLARACIONES = new Set([
  'mama', 'mamá', 'papa', 'papá', 'tio', 'tío', 'tia', 'tía',
  'abuelo', 'abuela', 'tutor', 'tutora', 'madre', 'padre',
  'sr', 'sra', 'srita', 'lic', 'ing',
])

const tokens = (t) => String(t || '').trim().split(/\s+/).filter(Boolean)

// El inicio del apellido que TERMINA en el indice `i`: se camina a la izquierda
// mientras haya particulas.
const inicioApellido = (t, i) => {
  let j = i
  while (j - 1 >= 0 && PARTICULAS.has(t[j - 1].toLowerCase())) j -= 1
  return j
}

export const partirNombre = (texto) => {
  const t = tokens(texto)
  let caso = null

  while (t.length && ACLARACIONES.has(t[t.length - 1].toLowerCase())) {
    t.pop()
    caso = 'ruido'
  }

  if (t.length === 0) return { nombres: '', apellidos: '', caso: 'vacio' }
  if (t.length === 1) return { nombres: t[0], apellidos: '', caso: caso || 'solo_nombre' }
  if (t.length === 2) return { nombres: t[0], apellidos: t[1], caso: caso || 'ok' }

  const iMaterno = inicioApellido(t, t.length - 1)
  // Todo son particulas menos la ultima palabra: no hay como partirlo.
  if (iMaterno === 0) return { nombres: t.join(' '), apellidos: '', caso: caso || 'solo_nombre' }

  const iPaterno = inicioApellido(t, iMaterno - 1)
  // No queda nada a la izquierda: hay UN solo apellido, con particulas.
  if (iPaterno === 0) {
    return {
      nombres: t.slice(0, iMaterno).join(' '),
      apellidos: t.slice(iMaterno).join(' '),
      caso: caso || 'un_apellido',
    }
  }

  return {
    nombres: t.slice(0, iPaterno).join(' '),
    apellidos: t.slice(iPaterno).join(' '),
    caso: caso || 'ok',
  }
}

// El apellido paterno: la primera palabra de `apellidos`, con sus particulas.
// Es lo que nombra a la familia.
export const apellidoPaterno = (apellidos) => {
  const t = tokens(apellidos)
  if (t.length === 0) return ''
  let i = 0
  while (i < t.length && PARTICULAS.has(t[i].toLowerCase())) i += 1
  return t.slice(0, i + 1).join(' ')
}
